import { useEffect, useState } from 'react'
import { countries } from '../countriesNames'
import styled from '@emotion/styled'
import { Alert, Box, Button, Collapse, FormControl, Stack, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

const NewsletterFormContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    min-width: 30%;
    font-family: "Poppins", sans-serif;
    color: var(--white)
`;


const NewsletterForm = () => {

    const { t } = useTranslation();
    const [open, setOpen] = useState<boolean>(false);
    const [open1, setOpen1] = useState<boolean>(false);

    type countryObject = {
        name: string,
        code: string
    }[]

    const [firstOption, setFirstOption] = useState<String | undefined>("Afghanistan")
    const [location, setLocation] = useState("")

    const [subscriberName, setSubscriberName] = useState<String>("")
    const [subscriberEmail, setSubscriberEmail] = useState<String>("")


    const getUserLocation = async () => {
        try {
            const response = await fetch('https://ipapi.co/json/', {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            });

            if (!response.ok) {
                console.log("Error fetching location:", response.status);
            }

            const data = await response.json();
            setLocation(data.country || 'DE');
            return data.country || 'DE';
        } catch (error) {
            console.error('Failed to fetch location:', error);
            setLocation('DE');
            return 'DE';
        }
    };


    useEffect(() => {
        const getLocation = async () => {
            await getUserLocation();
        }
        getLocation()
    }, [location])

    useEffect(() => {
        const newCountry = countries.find(country => country.code === location)
        setFirstOption(newCountry?.name);
    }, [location])

    const country: countryObject = countries.map((item) => item)


    const handleNewsletterSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        const options = {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                subject: 'NEWSLETTER',
                content: `Name: ${subscriberName}\nCountry: ${location}\nEmail: ${subscriberEmail}`,
            }),
        };

        try {
            const res = await fetch('https://rokk-management-core.de:5551/api/v1/application/emailSend', options);
            if (res.ok) {
                setOpen(true);
            } else {
                setOpen1(true);
            }
        } catch (error) {
            setOpen1(true);
        }
    };



    return (

        <NewsletterFormContainer>

            <FormControl
                component="form"
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px'
                }}
                onSubmit={handleNewsletterSubmit}
            >
                <TextField
                    fullWidth
                    variant="outlined"
                    label={t('newsletter.name')}
                    name="name"
                    onChange={(event) => setSubscriberName(event.target.value)}
                    sx={{
                        '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                                borderColor: '#ffffff80',
                                fontFamily: 'Poppins, sans-serif',
                            },
                            '&:hover fieldset': {
                                borderColor: '#ffffff80',
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: '#ff8303',
                            },
                            '& input': {
                                color: '#ffffff',
                            },
                        },
                        '& label': {
                            color: '#ffffff80',
                            fontFamily: 'Poppins, sans-serif',
                            '&.Mui-focused': {
                                color: '#ff8303',
                            },
                        },
                        '& .MuiFormHelperText-root': {
                            color: '#ffffff',
                        },
                        '& input': {
                            color: '#ffffff',
                        },
                    }}
                    required
                />

                {/* Country Selector */}

                <TextField
                    id="filled-select-country"
                    select
                    label="COUNTRY"
                    defaultValue={"DE"}
                    SelectProps={{
                        native: true,
                    }}
                    variant="filled"
                    sx={{
                        backgroundColor: 'var(--light-gray)',
                        borderRadius: '5px',
                        color: 'var(--white)',
                        '& .MuiInputLabel-root': {
                            color: '#dfdfdf',
                            fontFamily: 'Poppins, sans-serif',
                        },
                        '& .MuiFilledInput-root': {
                            color: '#ff8303'

                        },
                        minWidth: '300px'
                    }}
                    required
                >


                    {country.map((countryName, index) => (
                        <option key={index} value={countryName.code}>{countryName.name}</option>
                    ))}
                </TextField>


                <TextField
                    fullWidth
                    variant="outlined"
                    label="EMAIL"
                    name="email"
                    type="email"
                    onChange={(event) => setSubscriberEmail(event.target.value)}
                    sx={{
                        background: 'var(--light-gray)',
                        fontFamily: 'Poppins, sans-serif',
                        borderRadius: '5px',
                        '& .MuiOutlinedInput-root': {
                            '&:hover fieldset': {
                                borderColor: '#ffffff80',
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: '#ff8303',
                            },
                            '& input': {
                                color: '#ffffff',
                                fontFamily: 'Poppins, sans-serif',
                            },
                        },
                        '& label': {
                            color: '#ffffff80',
                            '&.Mui-focused': {
                                color: '#ff8303',
                                fontFamily: 'Poppins, sans-serif',
                            },
                        },
                        '& .MuiFormHelperText-root': {
                            color: '#ffffff',
                        },
                        '& input': {
                            color: '#ffffff',
                            fontFamily: 'Poppins, sans-serif',
                        },
                    }}
                    required
                />

                <Button
                    fullWidth
                    type='submit'
                    sx={{
                        color: '#ffffff',
                        fontWeight: 'bold',
                        fontSize: '16px',
                        background: '#ff8303',
                        borderRadius: '8px',
                        '&:hover': {
                            background: '#ff8303'
                        },
                        padding: '12px 24px'
                    }}>
                    SUBSCRIBE
                </Button>

            </FormControl>
            <Box>
                <Collapse in={open}>
                    <Stack sx={{ width: '100%' }} spacing={2}>
                        <Alert onClose={() => { setOpen(false) }} severity="success">Subscribed!</Alert>
                    </Stack>
                </Collapse>
            </Box>

            <Box>
                <Collapse in={open1}>
                    <Stack sx={{ width: '100%' }} spacing={2}>
                        <Alert onClose={() => { setOpen1(false) }} severity="error">Something went wrong</Alert>
                    </Stack>
                </Collapse>
            </Box>
        </NewsletterFormContainer>
    )
}

export default NewsletterForm